type TrackerOptions = {
  app: string;
  apiBaseUrl?: string;
  getUserId?: () => string | null;
};

let installed = false;
let lastSentAt = 0;
const THROTTLE_MS = 2_000;

function getEndpoint(opts: TrackerOptions): string {
  const base = opts.apiBaseUrl ?? '';
  return `${base}/api/errors/client`;
}

async function postError(opts: TrackerOptions, payload: Record<string, unknown>): Promise<void> {
  const now = Date.now();
  if (now - lastSentAt < THROTTLE_MS) return;
  lastSentAt = now;
  try {
    await fetch(getEndpoint(opts), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...payload,
        app: opts.app,
        userId: opts.getUserId?.() ?? null,
        url: window.location.href,
        userAgent: navigator.userAgent,
      }),
      keepalive: true,
    });
  } catch {
    // never throw from the tracker itself
  }
}

export function installErrorTracker(opts: TrackerOptions): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  window.addEventListener('error', (event) => {
    const err = event.error;
    void postError(opts, {
      message: err?.message ?? event.message ?? 'Unknown error',
      stack: err?.stack ?? '',
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason instanceof Error ? reason.message : String(reason ?? 'Unhandled rejection');
    const stack = reason instanceof Error ? reason.stack ?? '' : '';
    void postError(opts, { message, stack });
  });
}

export function reportClientError(opts: TrackerOptions, err: Error, extra?: { componentStack?: string }): void {
  void postError(opts, {
    message: err.message,
    stack: err.stack ?? '',
    componentStack: extra?.componentStack,
  });
}
